import { WarningFilled } from "@ant-design/icons";
import { Alert, Modal } from "antd";
import { useDeleteExpense } from "../../api/api.delete";
import { IExpense2 } from "../../types/types";

export default function DeleteExpenseDialog({
  open,
  onCancel,
  onOk,
  expense,
}: {
  expense?: IExpense2;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  const { mutateAsync, error } = useDeleteExpense(expense?.groupId);

  const handleSubmit = () => {
    if (expense) {
      mutateAsync({ expenseId: expense!.id }).then(onOk);
    }
  };

  return (
    <Modal
      title="Delete Expense"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
    >
      <div className="flex flex-col mb-10">
        {error && (
          <Alert type="error" title={"Unable to process. Please try again"} />
        )}
        <div className="mt-4 flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3">
          <div className="mt-0.5">
            <WarningFilled
              className="text-orange-500"
              style={{ fontSize: 18 }}
            />
          </div>

          <div className="flex flex-col">
            <p className="font-semibold text-red-500">Delete Confirmation</p>

            <p className="text-sm text-red-600">
              Are you sure you want to delete this item? This action cannot be
              undone.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
